import { Component, inject, signal } from '@angular/core';
import { VendorsService } from '../../../core/services/vendors.service';
import { ListingVendor } from '../../../core/models/listing-vendor';
import { fadeAnimation } from 'angular/app/core/animations/fade.animation';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-vendors-list-page',
  animations: [fadeAnimation],
  template: `
    <app-page-section
      headerBackground="right"
      padding="sm"
      [headerBackgroundBottomSeparator]="true"
      backgroundColor="white"
    >
      <h1
        class="bordered mx-auto text-center text-pretty lg:w-1/2"
        [attr.data-text]="'vendors-list.hero.title-text' | transloco"
        [innerHTML]="'vendors-list.hero.title-html' | transloco"
      ></h1>

      <p
        class="mx-auto mt-10 text-center text-pretty lg:w-1/2"
        >{{ 'vendors-list.hero.subtitle' | transloco }}</p
      >
    </app-page-section>

    <app-page-section padding="sm" backgroundColor="white">
      @if (loading() && vendors().length === 0) {
        <div
          class="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-10 xl:grid-cols-4"
        >
          @for (placeholder of skeletonPlaceholders; track $index) {
            <app-vendor-card-skeleton></app-vendor-card-skeleton>
          }
        </div>
      } @else {
        <div class="-mt-10 lg:mt-0"></div>
        <div
          class="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-10 xl:grid-cols-4"
          [@fadeAnimation]="'in'"
        >
          @for (vendor of vendors(); track vendor.slug) {
            <app-vendor-card [vendor]="vendor"></app-vendor-card>
          }
        </div>
      }
    </app-page-section>
  `,
  styles: ``,
  standalone: false,
})
export class VendorsListPageComponent {
  vendors = signal<ListingVendor[]>([]);
  loading = signal<boolean>(true);
  // Cartes de chargement affichées pendant le chargement des vendors
  skeletonPlaceholders = Array.from({ length: 8 });
  store = inject(Store);
  vendorsService = inject(VendorsService);

  async ngOnInit() {
    await this.loadVendors();
  }

  private async loadVendors() {
    try {
      const vendorsResponse = await this.vendorsService.findAllForListing();
      this.vendors.set(vendorsResponse.data);
    } catch (exception) {
      console.error(exception);
    } finally {
      this.loading.set(false);
    }
  }
}
